"use client";

import { useTranslations } from "next-intl";
import Icon from "@repo/ui/components/ui/icon/icon";

export default function Whatsapp({ logged }: { logged: boolean }) {
  const t = useTranslations("Help.whatsapp");

  if (logged) {
    return (
      <section className="pb-[80px] max-md:pt-[40px]">
        <h3>{t("title")}</h3>
        <div className="flex gap-10 max-md:gap-5">
          <p className="mt-[20px] text-[20px] max-md:text-[18px]">
            {t.rich("content", {
              br: () => <br />,
              whatsapp: (chunks) => (
                <a
                  href="https://wa.me/393519546854"
                  target="_blank"
                  className="text-primary-magenta underline"
                >
                  {chunks}
                </a>
              ),
              call: (chunks) => (
                <a
                  href="tel:00393519546854"
                  target="_blank"
                  className="text-primary-magenta underline"
                >
                  {chunks}
                </a>
              ),
              email: (chunks) => (
                <a
                  href="mailto:customerservice@ipriceit.it"
                  target="_blank"
                  className="text-primary-magenta underline"
                >
                  {chunks}
                </a>
              ),
            })}
          </p>
          <a href="https://wa.me/393519546854" target="_blank">
            <Icon
              className="w-[50px] h-[50px] max-md:w-[30px] max-md:h-[30px] fill-[#25D366] mt-4"
              icon="Whatsapp"
            />
          </a>
        </div>
      </section>
    );
  }

  return <></>;
}
